import React, { useContext, useEffect, useRef } from 'react';
import { type ExperienceHostedFooterCard } from '@bbkAdminRedux/rtkq/experience.slice';
import { cs } from '@bbkAdminUtils/css-utils';
import CustomerHtml from '@bbkFunnelComponents/customer_html/customer_html';
import DesignElement from '@bbkFunnelComponents/design-element/design-element';
import {
  REFS_CONTEXT_FUNNEL_PREFIX,
  RefsContext,
} from '@bbkFunnelUtils/refs.context';
import { makeClassNameSafe } from '@bbkFunnelUtils/utils';

type Props = {
  card: ExperienceHostedFooterCard;
};

export const HostedFooter: React.FC<Props> = ({
  card,
  card: {
    requires: {
      footer: { title },
    },
  },
}) => {
  const refsPrefix = REFS_CONTEXT_FUNNEL_PREFIX;
  const refsCtx = useContext(RefsContext);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(
    () => refsCtx?.addRef(`${refsPrefix}-footer`, sectionRef),
    [sectionRef]
  );

  return (
    <DesignElement name="Hosted Footer" noCard={!card}>
      <div
        className={cs('hosted-footer', makeClassNameSafe(card.name))}
        ref={sectionRef}
      >
        <div
          className={cs('hosted-footer-content', 'tw-py-4', 'tw-text-center')}
        >
          <CustomerHtml value={title} />
        </div>
      </div>
    </DesignElement>
  );
};
